import { z } from 'zod';
/**
 * Money Suite M1 — fleet statistics query. The client always sends an
 * explicit ISO range (the picker computes it); same datetime convention as
 * the loads list's completedFrom/completedTo.
 */
export const statsQuerySchema = z.object({
    from: z.string().datetime(),
    to: z.string().datetime(),
});
//# sourceMappingURL=stats.js.map